import Cookies from 'js-cookie'
import { CommonService } from '@/api'
import { parseTime } from '@/utils'
const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  ifShowMenu: true,
  device: 'desktop',
  showNotCertifi: false,
  commonData: {},
  pageLoading: false,
  commonMessageList: []
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  // 切换左边菜单是否展示
  TOGGLE_MENU: (state, ifShowMenu) => {
    state.ifShowMenu = ifShowMenu
  },
  // 切换未认证弹框是否展示
  TOGGLE_NOTCERTIFI: (state, showNotCertifi) => {
    state.showNotCertifi = showNotCertifi
  },
  SET_COMMOM_DATA: (state, data) => {
    state.commonData = data
  },
  TOGGLE_LOADING: (state, ifshow) => {
    state.pageLoading = ifshow
  },
  SET_MESSAGE_LIST: (state, list) => {
    state.commonMessageList = list
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    ('TOGGLE_DEVICE', device)
  },
  toggleMenu({ commit }, ifShowMenu) {
    commit('TOGGLE_MENU', ifShowMenu)
  },
  getCommonData({ commit }) {
    return new Promise((resolve, reject) => {
      CommonService.getCommonData().then(response => {
        commit('SET_COMMOM_DATA', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessage({ commit }) {
    return new Promise((resolve, reject) => {
      let params = {
        page: {
          pageNumber: 1,
          pageSize: 3
        },
        searchData: {}
      }
      CommonService.queryMessageList(params).then(res => {
        if (res.status) {
          let messageList = res.data.content.map(_ => {
            _.createdTime = parseTime(_.createdTime)
            return _
          })
          commit('SET_MESSAGE_LIST', messageList)
        }
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
